export default "__VITE_ASSET__7dc3876c__"